module.exports = __webpack_public_path__ + "img/Foto_MontageElektrik-DL-5072_2019.ff8d1ebf.jpg";